<template>
    <div>
        <status-bar :status="status"></status-bar>
        <div class="container" v-if="status==8||status==9">
            <img src="../../assets/ico_submit.png"/>
            <p class="title">报名信息已提交，审核中… </p>
            <p class="msg">您的报名信息已提交至当地分公司</p>
            <p class="msg">我们会尽快与您取得联系，请耐心等</p>
        </div>
        <div class="container" v-else>
            <img src="../../assets/ico_smile.png"/>
            <p class="title">请您按时参加面试，感谢您的关注！ </p>
            <div class="interview_msg">
                <img src="../../assets/info_left.png"/>
                <span>面试信息</span>
                <img src="../../assets/info_right.png"/>
            </div>
            <div class='address'>
            <ul><li>时间：</li><li>{{datas.date_desc}} {{datas.hour_span}}</li></ul>
            <ul><li>考点：</li><li>{{datas.name}}</li></ul>
            <ul><li>地址：</li><li>{{datas.address}}</li></ul>
            <ul><li>备注：</li><li class="tips">请携带本人身份证及驾驶证原件</li></ul>
            </div>
        </div>
    </div>
</template>
<script>
import { getSignUpInfo } from '../../utils/actions'
import statusBar from '@/components/StatusBar'
import { changeHistory } from '../../utils/common.js'
import{mapGetters} from 'vuex'
export default {
  data () {
    return {
      status: '',
      datas: {}
    }
  },
  components: {
    statusBar
  },
   computed: {
    ...mapGetters({
      userInfo:'getUserInfo'
    })
  },
  created () {
    this.status = this.$route.params.status
    this.getSignUpInfo()
    changeHistory()
  },
  methods: {
    async getSignUpInfo () {
      let _this = this
      let data = await getSignUpInfo({
        id: _this.userInfo.id,
        token: _this.userInfo.token
      })
      if (data && data.data) {
        _this.datas = data.data.interview_booking
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
    width: 100%;
    text-align: center;
    margin-top: 1.36rem;
    font-size: .28rem;
    img{
        height: auto;
        width: 1.32rem;
    }
    .msg{
        font-size: .24rem;
    }
    .title{
        margin: .2rem 0;
    }
}
.interview_msg{
    margin: .6rem 0 .42rem 0;
    img{
        width: .98rem;
        height: auto;
        vertical-align: bottom;
        padding-bottom: .09rem;
    }
    span{
        font-size: .28rem;
        color: #323233;
        margin: 0 .28rem;
    }
}
.address{
    width: 90%;
    margin-left: 5%;
    ul li:first-child{
        max-width: 20%;
        text-align: right;
        float: left;
        width: 1.4rem;
    }
    ul li:last-child{
        width: 75%;
        text-align: left;
        float: left;
    }
    li{
        display: inline-block;
    }
    ul{
         line-height: .44rem;
    }
    ul:after{
        content: '';
        display: block;
        clear: both;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/msg-audit/index.vue